import { UseGenericFetch, useGenericFetch } from "../../../api/customFetchHook";
import { getPipelines } from "../../../api/pipelineApi";
import { Pipeline } from "./types";

export function useGetPipelines(): UseGenericFetch<Pipeline[]> {
  return useGenericFetch<Pipeline[]>([], getPipelines);
}
